
        import {registerPageAdapter} from '@src/lib/utils/pageAdapter';
        const initPage = async () => {
            await registerPageAdapter({
                openThemeAdapter: true,
                openFontAdapter: true,
                // 该页面rem规则和默认的不一致，其他页面按需使用该属性
                closeRemAdapter: true
            });
            document.getElementById('app').style.visibility = 'visible';
        };
        initPage();

        var docEl = document.documentElement;
        var clientWidth = docEl.clientWidth;
        if (clientWidth) {
            docEl.style.fontSize = clientWidth >= 600 ? '100px' : 100 * (clientWidth / 414) + 'px';
        }
    